import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MRT_ColumnDef, MRT_VisibilityState } from 'mantine-react-table'
import { useLanguageStore } from '@/widgets/LanguageSelect/model/store'
import { useDefaultManager } from '@/entities/DefaultManager/api/default-manager-api'
import { Badge } from '@mantine/core'
import {
  convertPhoneNumberToString,
  findLabelByValue,
  formatDateForTable,
} from '@/shared/lib/utils'
import { useTranslatedEnums } from '@/shared/helpers/apiEnumTypesOptions'

export const useDefaultManagerTable = () => {
  const { data: defaultManager, isLoading, isError } = useDefaultManager()
  const { language } = useLanguageStore()
  const { t } = useTranslation(['userManagement', 'common'])
  const { userRoleOptions, userStatusOptions } = useTranslatedEnums()

  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>({
    hash_slug: false,
    created_at: false,
    city: false,
    status: false,
  })

  const defaultManagerData = defaultManager ? [defaultManager] : []

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'created_at',
        header: t('userManagement:registration_date'),
        Cell: ({ cell }) => formatDateForTable(cell.getValue() as string, language),
      },
      {
        accessorKey: 'id',
        header: 'ID',
        size: 90,
      },
      {
        accessorKey: 'hash_slug',
        header: 'Hash',
      },
      {
        accessorKey: 'fullname',
        header: t('userManagement:username'),
        Cell: ({ row }) => <div className='text-sm font-semibold'>{row.original.fullname}</div>,
      },
      {
        accessorKey: 'email',
        header: t('userManagement:email'),
      },
      {
        accessorKey: 'phone',
        header: t('userManagement:phone'),
        Cell: ({ row }) => (
          <div className='text-sm'>{convertPhoneNumberToString(row.original.phone ?? null)}</div>
        ),
      },
      {
        accessorKey: 'role',
        header: t('common:library_items.user_role.sing'),
        Cell: ({ row }) => {
          return (
            <Badge size='sm'>{findLabelByValue(userRoleOptions, row.original.role ?? 4)}</Badge>
          )
        },
      },
      {
        accessorKey: 'status',
        header: t('common:library_items.user_status.sing'),
        Cell: ({ row }) => {
          return (
            <Badge size='sm'>{findLabelByValue(userStatusOptions, row.original.status ?? 4)}</Badge>
          )
        },
      },
      {
        accessorKey: 'city',
        header: t('userManagement:city'),
        Cell: ({ row }) => <div className='text-sm font-semibold'>{row.original?.city ?? '-'}</div>,
      },
    ],
    [language],
  )
  return {
    defaultManager,
    defaultManagerData,
    columns,
    isErrorDefaultManager: isError,
    isLoadingDefaultManager: isLoading,
    columnVisibility,
    setColumnVisibility,
  }
}
